import CmpList from './CmpList/CmpList';

const Cmp = (props) => {
  const episodeHeaderData = props.episodeHeaderData;
  //console.log(episodeHeaderData)
  return (
    <>
      <CmpList episodeHeaderData={episodeHeaderData}/>
    </>
  );
};

export default Cmp;
